module.exports = __webpack_public_path__ + "space_mockup_tea_paper_design_workshop.jpg?689fefcb80493fa43722969aabe20bff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/josif_pancic/space_mockup_tea_paper_design_workshop.jpg
// module id = 80
// module chunks = 0